'use strict';

angular.module('webAgro1App').controller('DepositosPadraoCtrl', function($location, $scope, $rootScope, PropriedadesService, Flash, LoadingService, MessagesService) {

  $scope.propriedadesDepositos = [];

  var initialize = function() {
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.depositos.canRead) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      $scope.listAll();
    }, $rootScope.errorRootInitialize);
  };

  $scope.listAll = function() {
    LoadingService.showLoading();
    PropriedadesService.all().then(function(propriedades) {
      $scope.propriedadesDepositos = propriedades.data || [];
    }, function() {
      MessagesService.alert('Não foi possível buscar os depósitos.');
    }).finally(LoadingService.hideLoading);
  };

  initialize();
});
